<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <div class="row" v-if="selectedMessage">
      <div class="col-lg-7">
        <div class="col-lg-12 main_message_info">
          <div class="info_wrapper">
            <h5>أسم المرسل</h5>
            <span>
              {{ selectedMessage.contact.name }}
            </span>
          </div>
          <div class="info_wrapper" v-if="selectedMessage.contact.subject">
            <h5>موضوع الرسالة</h5>
            <span>
              {{ selectedMessage.contact.subject }}
            </span>
          </div>
          <div class="info_wrapper">
            <h5>البريد الالكتروني المرسل</h5>
            <span>
              {{ selectedMessage.contact.email }}
            </span>
          </div>
          <div class="info_wrapper">
            <h5>رقم هاتف المرسل</h5>
            <span>
              {{ selectedMessage.contact.phone }}
            </span>
          </div>
          <div class="info_wrapper" v-if="selectedMessage.contact.service">
            <h5>الخدمة المطلوبة</h5>
            <span>
              {{ selectedMessage.contact.service.name }}
            </span>
          </div>
          <div class="" v-if="selectedMessage.contact.content">
            <h5>محتوي الرسالة</h5>
            <span>
              {{ selectedMessage.contact.content }}
            </span>
          </div>
        </div>
        <div class="reply_wrapper">
          <div
            class="input_wrapper align-items-end top_label col-lg-12 mx-auto"
          >
            <textarea
              class="form-control"
              rows="5"
              v-model="content"
              type="text"
              placeholder="اضف رد"
              @keydown.enter="send"
            ></textarea>

            <v-btn class="active center send_message" @click="send">
              <i class="fas fa-paper-plane"></i>
            </v-btn>
            <!-- <v-icon @click="send" class="send_button">fal fa-send</v-icon> -->
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div v-if="replies.length" class="selected_message mx-auto px-3">
          <h4>الردود</h4>
          <div v-for="reply in replies" :key="reply.id" class="message_wrapper">
            <div class="admin_info">
              <img :src="reply.admin.image" width="30" />
            </div>
            <div class="">
              <div class="message_content">
                <h5>
                  {{ reply.admin.fullname }}
                  <template v-if="reply.admin.role">
                    ({{ reply.admin.role }})
                  </template>
                </h5>
                <p>{{ reply.reply }}</p>
              </div>
              <span>
                {{ reply.admin.email }} {{ reply.admin.created_at }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  props: ["id"],
  components: {
    MainFilter,
  },
  data() {
    return {
      selectedMessage: null,
      content: null,
      messages: [],
      // ========== Statistics
      statisticsItem: null,
      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created\\
      replies: [],
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loading
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.messages.title"),
          disabled: false,
          href: "",
        },
        {
          text: this.$t("breadcrumb.messages.readed"),
          disabled: false,
          href: "",
        },
      ],
      filter: null,
    };
  },
  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },
  methods: {
    showItem() {
      this.axios({
        method: "GET",
        url: `contact/${this.id}`,
      })
        .then((res) => {
          this.selectedMessage = res.data.data;
          this.replies = res.data.data.contact.replies;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `contact/${this.itemtoDelete.id}`,
      })
        .then((res) => {
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================
    send(e) {
      if (e) {
        if (
          (e.ctrlKey && e.key === "Enter") ||
          (e.shiftKey && e.key === "Enter")
        ) {
          this.content += "\n";
          return;
        } else {
          e.preventDefault();
        }
      }
      const formData = new FormData();
      formData.append("reply", this.content);
      // formData.append("email", this.selectedMessage.contact.email);
      this.axios({
        method: "POST",
        url: `contacts/${this.id}/reply`,
        data: formData,
      })
        .then((res) => {
          if (res.data.data) {
            this.replies = res.data.data.contact.replies;
          } else {
            this.showItem();
          }
          this.content = null;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.loading = false;
        });
    },
  },
  created() {},
  mounted() {
    this.showItem();
  },
};
</script>
<style lang="scss">
.selected_message {
  padding: 0px !important;
  padding-inline: 0;
  // width: 100%;
  min-height: 400px;
  height: fit-content;
  overflow: hidden;
  box-shadow: 0 2px 8px rgb(0 0 0 / 11%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-block: 15px;
  .show_message {
    text-align: center;
    // padding-block:10px ;
    font-size: 17px;
    .header {
      background: var(--mainColor-2);
      width: 100%;
      padding-inline: 10px;
      direction: ltr;
      display: flex;
      justify-content: space-between;
      margin-block-end: 15px;
      h3 {
        color: #fff;
        line-height: 40px;
        margin: 0;
      }
      .v-icon {
        color: #fff;
        margin-inline-start: 7px;
        line-height: 40px;
      }
    }
    a {
      color: var(--mainColor-2) !important;
    }
  }
  .message_content {
    border: 1px solid #eee;
    border-radius: 15px 15px 0px 15px;
    margin-block-start: 20px;
    margin-inline-start: 10px;
    padding: 5px 10px 0;
    text-align: center;
    background: #eee;
    width: fit-content;
    h5 {
      font-size: 16px;
      color: #182156;
    }
    p {
      font-size: 16px;
    }
  }

  .admin_info {
    img {
      width: 35px;
      height: 35px;
      object-fit: cover;
      border-radius: 50%;
      display: inline-block;
      margin-inline-end: 10px;
    }
  }
  .message_wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .recent_messages {
    display: none;
  }
  span {
    font-size: 15px;
    text-align: right;
    display: inline-block;
    width: 100%;
    margin-inline-start: 10px;
  }
  .reply_wrapper {
    input,
    textarea {
      overflow: hidden;
      resize: none;
      outline: none;
      width: 100%;
      background: #000; //  var(--cardBgColor
      height: 55px;
      color: #c2c6dc; // var(--mainColor-1)
      padding: 10px;
      border-radius: 15px;
      outline: none;
      transition: all 0.2s linear;
      font-size: 15px;
      border: 1px solid #182156; // var(--mainColor-5)
      &:focus {
        padding-right: 10px;
      }
      &::placeholder {
        color: #a8a8a8;
        font-size: 17px;
      }
    }
    .send_button {
      width: 100%;
      .send_message {
        border: none;
        outline: none;
        overflow: unset;
        background: var(--mainColor-2); // var(--dark)
        color: #fff;
        display: inline-block;
        font-weight: 400;
        text-align: center;
        padding: 12px 22px;
        font-size: 15px;
        line-height: 1;
        border-radius: 0.5px;
        // margin: 0 auto;
        margin-inline-start: auto;
        display: block;
        @media (max-width: 500px) {
          padding: 10px 11px;
        }
      }
    }
  }
}
.selected_message div:nth-of-type(odd) {
  // justify-content: flex-end;
}
.main_message_info {
  h5 {
    font-size: 16px;
  }
  span {
    font-size: 16px;
    color: var(--mainColor-2);
  }
  .info_wrapper {
    margin-block: 20px;
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
}
</style>
